'use client';

import { Checkbox } from '@ps/ui/atoms/checkbox';
import { Label } from '@ps/ui/atoms/label';

// ─── Props ───────────────────────────────────────────────────────────────

export interface CommunicationConsentProps {
  sellerName: string;
  offerConsent: boolean;
  phoneConsent: boolean;
  onOfferConsentChange: (checked: boolean) => void;
  onPhoneConsentChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Show the marketing-offers consent (RN: gated on `isShowEmail`). Default true. */
  showOfferConsent?: boolean;
  /** Show the share-phone consent (RN: gated on `isShowPhone`). Default true. */
  showPhoneConsent?: boolean;
  /** Text color for labels. Default 'text-content-1'. */
  labelTextColor?: string;
}

// ─── Component ───────────────────────────────────────────────────────────

export function CommunicationConsent({
  sellerName,
  offerConsent,
  phoneConsent,
  onOfferConsentChange,
  onPhoneConsentChange,
  disabled,
  showOfferConsent = true,
  showPhoneConsent = true,
  labelTextColor = 'text-content-1',
}: CommunicationConsentProps) {
  return (
    <div className="space-y-3">
      {showOfferConsent && (
        <div className="flex items-start gap-2">
          <Checkbox
            id="offer-consent"
            checked={offerConsent}
            onCheckedChange={
              disabled
                ? undefined
                : checked => onOfferConsentChange(checked === true)
            }
            className="data-[state=checked]:bg-brand data-[state=checked]:border-brand data-[state=checked]:text-content-on-brand mt-0.5"
          />
          <Label
            htmlFor="offer-consent"
            className={`${labelTextColor} text-sm font-light leading-[1.2] tracking-[0.2px]`}
          >
            I agree to receive personalized offers from {sellerName}
          </Label>
        </div>
      )}

      {showPhoneConsent && (
        <div className="flex items-start gap-2">
          <Checkbox
            id="share-phone-consent"
            checked={phoneConsent}
            disabled={disabled}
            onCheckedChange={
              disabled
                ? undefined
                : checked => onPhoneConsentChange(checked === true)
            }
            className="data-[state=checked]:bg-brand data-[state=checked]:border-brand data-[state=checked]:text-content-on-brand mt-0.5"
          />
          <Label
            htmlFor="share-phone-consent"
            className={`${labelTextColor} text-sm font-light leading-[1.2] tracking-[0.2px]`}
          >
            I consent to share my phone number with {sellerName}
          </Label>
        </div>
      )}
    </div>
  );
}
